const dataEarn = [
  {
    title: 'Befriending, peer support and buddying',
    image: 'graphicBurst8',
  },
  {
    title: 'Sharing skills or experiences to improve or design services',
    image: 'graphicBurst9',
  },
  {
    title: 'Helping maintain or improve outdoor spaces',
    image: 'graphicBurst10',
  },
  {
    title: 'Supporting & setting up community groups',
    image: 'graphicBurst11',
  },
  {
    title: 'Administration or office support',
    image: 'graphicBurst12',
  },
  {
    title: 'Helping run services or activities, such as helping in a café or leading an art class',
    image: 'graphicBurst13',
  },
];

const dataSpend = [
  {
    title: 'Going to an art gallery or theatre',
    image: 'graphicBurst8',
  },
  {
    title: 'Visiting a cultural or historical venue',
    image: 'graphicBurst9',
  },
  {
    title: 'Completing a training course',
    image: 'graphicBurst10',
  },
  {
    title: 'Attending yoga or fitness classes',
    image: 'graphicBurst11',
  },
  {
    title: 'Having spa or beauty treatments',
    image: 'graphicBurst12',
  },
  {
    title: 'Going swimming or to the gym',
    image: 'graphicBurst13',
  },
];

export { dataEarn, dataSpend };
